import { RootState } from '..';
import { Module } from "vuex";
import { firestoreAction, firebaseAction } from 'vuexfire'
import { db, requestQuiz, quizStatus, rtdb } from '../db';

interface Quiz {
  id: string;
  isCurrent: boolean;
  title: string;
  questions: [];
}

interface QuizStatus {
  id?: string;
  date?: {_seconds: number};
  isCurrent?: boolean;
  unanswered?: number;
}

export interface QuizState {
  latest: Quiz | null;
  status: QuizStatus | null;
  answers: {} | null;
  award: {
    points?: number;
  } | null;
  leaderboard: [] | null;
  scoreboard: {
    [points: string]: number;
  } | null;
  rawquiz: {
    id: string;
  } | null;
}


const QuizModule: Module<QuizState, RootState> = {
  namespaced: true,
  state() {
    return {
      latest: null,
      status: null,
      answers: null,
      award: null,
      leaderboard: null,
      scoreboard: null,
      rawquiz: null,
      localAnswers: null,
    }
  },
  mutations: {
    'SET_STATUS': function (state, payload) {
      state.status = payload
    },
    'SET_LATEST': function(state, payload) {
      state.latest = payload
    }
  },
  actions: {
    async bindQuizStatus(context) {
      context.commit('SET_STATUS', (await quizStatus()).data)
    },
    async requestQuiz(context) {
      const quiz = (await requestQuiz()).data
      context.commit('SET_LATEST', quiz)
    },
    async setAnswer(context, payload) {
      localStorage.setItem(`lidate.quiz.${payload.id}.${payload.question}`, payload.answer)
    },
    bindQuiz: firestoreAction((context, payload) => {
      if(context.state.rawquiz && context.state.rawquiz.id == payload) {
        //already bound
        return
      }
      return context.bindFirestoreRef('rawquiz', db.collection('quizzes').doc(payload))
    }),
    unbindQuiz: firestoreAction((context) => {
      return context.unbindFirestoreRef('rawquiz')
    }),

    bindLeaderboard: firestoreAction((context, payload) => {
      return context.bindFirestoreRef('leaderboard', 
        db.collection('quizAnswers')
          .doc(payload.id)
          .collection('awards')
          .orderBy('correct', 'desc')
          .orderBy('time', 'asc')
          .limit(5)
        )
    }),
    unbindLeaderboard: firestoreAction((context) => {
      return context.unbindFirestoreRef('leaderboard')
    }),
    bindScoreboard: firebaseAction((context, payload) => {
      return context.bindFirebaseRef('scoreboard', rtdb.ref(`leaderboards/${payload.id}`))
    }),
    unbindScoreboard: firebaseAction((context) => {
      return context.unbindFirebaseRef('scoreboard')
    }),
    bindQuizAward: firestoreAction((context, payload) => {
      return context.bindFirestoreRef('award', db
        .collection('quizAnswers')
        .doc(payload.id)
        .collection('awards')
        .doc(context.rootGetters.user.uid)
      )
    }),
    bindQuizAnswers: firestoreAction((context, payload) => {
      return context.bindFirestoreRef('answers', db
        .collection('quizAnswers')
        .doc(payload.id)
        .collection('answers')
        .doc(context.rootGetters.user.uid)
      )
    }),
    persistAnswers: firestoreAction((context, payload) => {
      const answers = Object
        .keys(localStorage)
        .filter(k => k.indexOf(`lidate.quiz.${payload.id}`) === 0)
        .sort()
        .map(k => {
          const v = localStorage.getItem(k)
          localStorage.removeItem(k)
          return v
        })

      return db
        .collection('quizAnswers')
        .doc(payload.id)
        .collection('answers')
        .doc(context.rootGetters.user.uid)
        .set({
          answers: answers,
        })
    })
  },
  getters: {
    myrank(state) {
      if(state.scoreboard && state.award && state.award.points) {
        const mypoints = state.award.points
        let betterPlayers = 0
        for(const [score, players] of Object.entries(state.scoreboard)) {
          if (parseInt(score) > mypoints) betterPlayers += players
        }
        return betterPlayers + 1
      }
      return null
    },
    current(state) {
      if(state.latest && state.latest.isCurrent) {
        return state.latest
      }

      return null
    }
  }
}

export default QuizModule